module.exports = __webpack_public_path__ + "static/media/amex.43bb450e_UI.svg";